import AboutUs1 from "./sections/AboutUs1";
import AboutUs2 from "./sections/AboutUs2";
import Banner from "./sections/PageBanner";
import Footer from "./sections/PageFooter";
import PageHeader from "./sections/PageHeader";
import ReactGA from "react-ga4";

ReactGA.initialize("G-FMCF2WQ3F6");

function PageHero() {
  return (
    <div
      className="relative w-full overflow-hidden flex flex-col justify-end"
      style={{ height: '52vh', minHeight: 360, background: '#052e16' }}
    >
      {/* Background image */}
      <img
        src="/images/v1/img12.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover select-none"
        style={{ opacity: 0.35 }}
      />
      {/* Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#052e16]/30 via-transparent to-[#052e16]/90 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-10 pb-14">
        <span className="flex items-center gap-3 mb-4">
          <span className="h-px w-8 bg-green-400" />
          <span
            className="text-green-400 text-xs tracking-[0.22em] uppercase font-medium"
            style={{ fontFamily: 'var(--font-body)' }}
          >
            LAPA Africa &mdash; WITS
          </span>
        </span>
        <h1
          className="text-5xl lg:text-6xl font-bold text-white leading-tight"
          style={{ fontFamily: 'var(--font-display)', textShadow: '0 2px 24px rgba(0,0,0,0.5)' }}
        >
          About <span className="text-green-400">WITS</span>
        </h1>
        <p
          className="mt-4 text-white/65 text-base max-w-xl leading-relaxed"
          style={{ fontFamily: 'var(--font-body)', textShadow: '0 1px 8px rgba(0,0,0,0.5)' }}
        >
          The Wildlife Information &amp; Tracking System &mdash; data-driven conservation intelligence
          protecting Africa&apos;s natural heritage.
        </p>
      </div>
    </div>
  );
}

export default function AboutUs() {
  ReactGA.send({ hitType: "pageview", page: "/about-us", title: "About Us" });

  return (
    <>
      <Banner />
      <PageHeader />
      <PageHero />
      <AboutUs1 />
      <AboutUs2 />
      <Footer />
    </>
  );
}
